




import {Component, Vue} from 'vue-property-decorator';
import TextInput from "@/components/Atoms/TextInput/TextInput.vue";
import TextInputGroup from "@/components/Molecules/TextInputGroup/TextInputGroup.vue";
import StepCardInfo from "@/components/Organisms/StepCardInfo/StepCardInfo.vue";
import StepCardInfoContent from "@/components/Molecules/StepCardInfoContent/StepCardInfoContent.vue";
import MemoModalContainer from "@/components/Organisms/MemoModalContainer/MemoModalContainer.vue";
import ButtonSuccessful from "@/components/Atoms/ButtonSuccessful/ButtonSuccessful.vue";
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";
import {ServiceFactory} from "@/services";
import {RecentSearchDto, RecentSearchModel, SearchFilter, SearchModel} from "@/share";
import Categories from "@/constants/category";

const MilestoneService = ServiceFactory.get('milestone')
const RecentSearchService = ServiceFactory.get('recentSearch')

@Component({
  components: {
    TextInput,
    TextInputGroup,
    StepCardInfo,
    StepCardInfoContent,
    MemoModalContainer,
    ButtonSuccessful,
    SvgRender
  }
})
export default class SearchResult extends Vue {
  private isLoading = false

  private keyword = this.$route.query.keyword
  private babyId = this.$route.params.id
  private data: SearchModel[] = []

  private amountResults = 0;

  private get isEmptyResult(): boolean {
    return this.data.length === 0
  }

  private get loadingClass(): string {
    if (this.isLoading) return 'invisible'
    return ''
  }

  created(): void {
    this.search()
  }

  private async search(): Promise<void> {
    const params: SearchFilter = new SearchFilter({
      babyId: this.babyId,
      keyword: this.keyword
    })

    this.isLoading = true
    this.data = await MilestoneService.search(params).catch(() => [])
    this.isLoading = false

    this.amountResults = this.data.length
  }

  private get categoryCurrent(): any {
    return (type: number) => {
      const category = Categories.find(o => o.key === type)
      return category ? category : Categories[0]
    }
  }

  private async handleRecentSearch(): Promise<any> {
    if (!this.keyword || this.isLoading) return
    const payload: RecentSearchDto = new RecentSearchDto({
      content: this.keyword
    })
    const response = await RecentSearchService.create(payload).catch(() => new RecentSearchModel({}))
    if (response.hasError) return // TODO handler error

    await this.search()
    return this.$router.push({name: 'routes.search.result', query: {keyword: this.keyword}, params: {id: this.babyId}})
  }

  private changeKeyword(value: string) {
    this.keyword = value
  }
}
